module.exports = __webpack_public_path__ + "static/img/aboutUs_headRight.43811f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img1/aboutUs_headRight.png
// module id = K3cx
// module chunks = 1